export const GIVE_GOUSTO_A_GO = {
  heading: 'Ready to give Gousto a Go?',
  body1:
    "If you're after the best value and the biggest choice, you're in the right place. With over 175 mouthwatering recipes every single week, Gousto's got something for every household, whether you're cooking for one or feeding a family of five.",
  body2:
    'Think global flavours, fancy gourmet nights, speedy 10-minute wonders and feel-good healthy picks - all delivered to your door. It’s like falling in love with dinner all over again.',
  subheadingBold: 'And the cherry on top?',
  subheading: 'New customers get a juicy deal:',
  body3: 'Now’s definitely the time to give it a whirl.',
  ctaText: 'Get your first box with 50% off now',
  altText:
    'A family around a kitchen table sharing a Gousto family favourite of baked salmon, Greek salad and minted couscous.',
}
